import RootRequest from 'GroomyRoot/assets/js/requests.js'
export default class Request extends RootRequest {
 
}
